export default {
  methods:{
    afterLogin: function(params){
      this.$sessionStorage.set('mb_id', params.mb_id);
      this.$sessionStorage.set('mb_no', params.mb_no);
      this.$sessionStorage.set('mb_name', params.mb_name);
      this.$sessionStorage.set('mb_hp', params.mb_hp);
      this.$sessionStorage.set('g_idx', params.g_idx);
      this.$sessionStorage.set('c_idx', params.c_idx);
      this.$sessionStorage.set('mb_ad_alarm', params.mb_ad_alarm);
      this.$sessionStorage.set('mb_alram', params.mb_alram);
      this.$sessionStorage.set('first', params.first);
    },
    getUserInfo: function(){
      let userInfo = {
        mb_id : this.$sessionStorage.get('mb_id'),
        mb_no : this.$sessionStorage.get('mb_no'),
        mb_name : this.$sessionStorage.get('mb_name'),
        mb_hp : this.$sessionStorage.get('mb_hp'),
        g_idx : this.$sessionStorage.get('g_idx'),
        c_idx : this.$sessionStorage.get('c_idx'),
        mb_ad_alarm : this.$sessionStorage.get('mb_ad_alarm'),
        mb_alram : this.$sessionStorage.get('mb_alram'),
        first : this.$sessionStorage.get('first')
      };
      return userInfo;
    }
  }
}
